import { useAdminUI } from "@/shared/config/admin";
import { useUser } from "@/shared/lib/hooks/useUser/useUser";

/**
 * Показывать ли новое меню кабинета и новые экраны «сайт без приложения».
 *
 * Пока — только админам: useAdminUI (он же учитывает «смотреть как
 * пользователь» — в этом режиме админ видит ровно то, что все). Пока список
 * динамических админов грузится, ответ «нет»: обычный человек не должен ни
 * на миг увидеть новое, а админ переключится, как только список придёт.
 */
export const useNavV5 = (): {
    enabled: boolean;
    isRealAdmin: boolean;
    loading: boolean;
    email: string;
    /** Админ включил «смотреть как пользователь» (известно и пока список грузится). */
    previewAsUser: boolean;
} => {
    const { user } = useUser();
    let email = typeof user === "object" && user?.email ? user.email : "";
    if (!email) {
        try {
            email = localStorage.getItem("site_user_email") || "";
        } catch {
            email = "";
        }
    }
    const { isAdmin, isRealAdmin, loading, previewAsUser } = useAdminUI(email);
    return { enabled: isAdmin, isRealAdmin, loading, email, previewAsUser };
};
